<template>
  <p>
    El radiómetro ultravioleta realiza mediciones en 4 regiones espectrales de
    la radiación ultravioleta (UV): 305, 320, 340 y 380 nm con un ancho de banda
    de 10 nm. Tiene un control de temperatura de 40°C. Adicionalmente tiene un
    sensor que registra la radiación activa fotosintéticamente (PAR, 400 – 700
    nm). En base a las mediciones espectrales UV determina el Indice UV solar
    para fines de información pública. Este instrumento cumple con las
    exigencias del programa de Vigilancia Atmosférica Global de la Organización
    Mundial de Meteorología (VAG/OMM).
  </p>

  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/radiometro-uv.webp"
    alt="Radiómetro ultravioleta"
  />
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Radiación espectral a 305 nm uW/(cm<sup>2</sup>.nm)</li>
    <li>Radiación espectral a 320 nm uW/(cm<sup>2</sup>.nm)</li>
    <li>Radiación espectral a 340 nm (uW/(cm<sup>2</sup>.nm)</li>
    <li>Radiación espectral a 380 nm uW/(cm<sup>2</sup>.nm)</li>
    <li>Radiación PAR (uE/(cm<sup>2</sup>.sec)</li>
    <li>Indice UV solar (adimensional)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    Biospherical Inc., GUV-511
  </p>
  <p>
    <b>País: </b> <br />
    EE.UU.
  </p>
  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.comm-tec.com/prods/mfgs/biospherical/brochures/guv-511&541.pdf"
      target="_blank"
      >https://www.comm-tec.com/prods/mfgs/biospherical/brochures/guv-511&541.pdf</a
    >
  </p>
  <p>
    <b>Responsable: </b> <br />
    lsuarez@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  // Obtener el nombre de la ruta

  name: "FotometroSolar",
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
